import React from 'react';

import QueryPageTemplate from 'src/pages/QueryPages/components/QueryPageTemplate';
import { PATHS } from 'src/constants/config';

const Successful = () => {
  return (
    <QueryPageTemplate queryStatuses={['successful']} title="Successful" path={PATHS.SUCCESSFUL.value} pageType="successful" showDeadline={false} />
  );
};

export default Successful;
